import { MeterBrandState } from './types';

const state = (): MeterBrandState => {
  return {
    meterBrands: [],
  };
};

export default state;
